module.exports = __webpack_public_path__ + "static/customize-phone-3-78800ea7f69fd607a9b2b4ea5983b9a1.png";